import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../utils/type';
import {
  selectChargerStatus,
  selectChargerStatusLoading,
  selectChargerStatusError,
} from '../services/chargerStatus/selectors';
import { getChargerStatus } from '../services/chargerStatus/crudFunctions';
import { ChargerStatusFilters } from '../model/reports';
import LoadingSpinner from '../../../elements/LoadingSpinner';
import ChargerTable from '../../../elements/ChargerTable';
import VendorSelect from '../../../elements/VendorSelect';
import StationSelect from '../../../elements/StationSelect';

const ChargerStatusAnalytics: React.FC = () => {
  const dispatch = useDispatch();
  const data = useSelector((s: RootState) => selectChargerStatus(s));
  const loading = useSelector((s: RootState) => selectChargerStatusLoading(s));
  const error = useSelector((s: RootState) => selectChargerStatusError(s));

  const [filters, setFilters] = useState<ChargerStatusFilters>({});

  useEffect(() => {
    dispatch<any>(getChargerStatus({}));
  }, [dispatch]);

  const handleFilter = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch<any>(getChargerStatus(filters));
  };

  return (
    <div>
      <div className="page-title">
        <div className="title_left">
          <h3>
            <i className="bi bi-ev-station me-2 text-success" />
            Charger Status Analytics
          </h3>
        </div>
      </div>

      <div className="x_panel">
        <div className="x_title">
          <h4>Filters</h4>
          <div className="clearfix" />
        </div>
        <div className="x_content">
          {error && (
            <div className="alert alert-danger">
              <i className="fas fa-exclamation-triangle me-2" />
              {error}
            </div>
          )}
          <form onSubmit={handleFilter}>
            <div className="row g-3 mb-3">
              <div className="col-md-4">
                <VendorSelect
                  value={filters.vendorId}
                  onChange={(id) =>
                    setFilters((f) => ({ ...f, vendorId: id, stationId: undefined }))
                  }
                />
              </div>
              <div className="col-md-4">
                <StationSelect
                  vendorId={filters.vendorId}
                  value={filters.stationId}
                  onChange={(id) => setFilters((f) => ({ ...f, stationId: id }))}
                />
              </div>
            </div>
            <div className="row g-3">
              <div className="col-12">
                <button type="submit" className="btn btn-success px-4">
                  <i className="fas fa-search me-2" /> Apply Filters
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {loading ? <LoadingSpinner /> : <ChargerTable data={data} />}
    </div>
  );
};

export default ChargerStatusAnalytics;
